export const lotto =[
    {
    _id: "5d142a69f3130bb9ad5f1277",
    ticketNumber: 7017,
    ticketName: "PAC-MAN",
    topPrize: 250000,
    topPrizeRemaining: "5 of 13",
    ticketCost: 5,
    launchDate: "2017-12-04T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-3.97",
    gameImageLink: "http://www.flalottery.com/scratch/7017pic.jpg",
    State: "FL",
    remainingPrizes: 5,
    totalPrizes: 13,
    prizePercentage: 0.3846153846
    },
    {
    _id: "5d142a69f3130bb9ad5f1278",
    ticketNumber: 5014,
    ticketName: "JOKER'S WILD",
    topPrize: 30000,
    topPrizeRemaining: "5 of 16",
    ticketCost: 2,
    launchDate: "2018-08-06T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.35",
    gameImageLink: "http://www.flalottery.com/scratch/5014pic.jpg",
    State: "FL",
    remainingPrizes: 5,
    totalPrizes: 16,
    prizePercentage: 0.3125
    },
    {
    _id: "5d142a69f3130bb9ad5f1279",
    ticketNumber: 5015,
    ticketName: "CASH MULTIPLIER",
    topPrize: 30000,
    topPrizeRemaining: "12 of 20",
    ticketCost: 2,
    launchDate: "2019-04-08T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.39",
    gameImageLink: "http://www.flalottery.com/scratch/5015pic.jpg",
    State: "FL",
    remainingPrizes: 12,
    totalPrizes: 20,
    prizePercentage: 0.6
    },
    {
    _id: "5d142a69f3130bb9ad5f127a",
    ticketNumber: 5013,
    ticketName: "POWER 5S",
    topPrize: 250000,
    topPrizeRemaining: "2 of 10",
    ticketCost: 5,
    launchDate: "2018-05-21T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.03",
    gameImageLink: "http://www.flalottery.com/scratch/5013pic.jpg",
    State: "FL",
    remainingPrizes: 2,
    totalPrizes: 10,
    prizePercentage: 0.2
    },
    {
    _id: "5d142a69f3130bb9ad5f127b",
    ticketNumber: 1422,
    ticketName: "CASH MONEY",
    topPrize: 500000,
    topPrizeRemaining: "7 of 8",
    ticketCost: 5,
    launchDate: "2019-05-20T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.07",
    gameImageLink: "http://www.flalottery.com/scratch/1422pic.jpg",
    State: "FL",
    remainingPrizes: 7,
    totalPrizes: 8,
    prizePercentage: 0.875
    },
    {
    _id: "5d142a69f3130bb9ad5f127c",
    ticketNumber: 1420,
    ticketName: "Fantastic 5's",
    topPrize: 50000,
    topPrizeRemaining: "9 of 10",
    ticketCost: 2,
    launchDate: "2019-05-20T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.38",
    gameImageLink: "http://www.flalottery.com/scratch/1420pic.jpg",
    State: "FL",
    remainingPrizes: 9,
    totalPrizes: 10,
    prizePercentage: 0.9
    },
    {
    _id: "5d142a69f3130bb9ad5f127d",
    ticketNumber: 1421,
    ticketName: "MONOPOLY BOARDWALK BINGO",
    topPrize: 150000,
    topPrizeRemaining: "3 of 4",
    ticketCost: 3,
    launchDate: "2019-05-20T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-3.99",
    gameImageLink: "http://www.flalottery.com/scratch/1421pic.jpg",
    State: "FL",
    remainingPrizes: 3,
    totalPrizes: 4,
    prizePercentage: 0.75
    },
    {
    _id: "5d142a69f3130bb9ad5f127e",
    ticketNumber: 1419,
    ticketName: "7-11-21",
    topPrize: 1000,
    topPrizeRemaining: "387 of 420",
    ticketCost: 1,
    launchDate: "2019-05-20T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.87",
    gameImageLink: "http://www.flalottery.com/scratch/1419pic.jpg",
    State: "FL",
    remainingPrizes: 387,
    totalPrizes: 420,
    prizePercentage: 0.9214285714
    },
    {
    _id: "5d142a69f3130bb9ad5f127f",
    ticketNumber: 1418,
    ticketName: "$50, $100 AND $500 BLOWOUT!",
    topPrize: 500,
    topPrizeRemaining: "4,961 of 16,071",
    ticketCost: 10,
    launchDate: "2019-04-08T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-8.88",
    gameImageLink: "http://www.flalottery.com/scratch/1418pic.jpg",
    State: "FL",
    remainingPrizes: 4,
    totalPrizes: 16,
    prizePercentage: 0.25
    },
    {
    _id: "5d142a69f3130bb9ad5f1280",
    ticketNumber: 1417,
    ticketName: "$500,000 CROSSWORD EXTRA PLAY",
    topPrize: 500000,
    topPrizeRemaining: "6 of 8",
    ticketCost: 5,
    launchDate: "2019-04-08T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.06",
    gameImageLink: "http://www.flalottery.com/scratch/1417pic.jpg",
    State: "FL",
    remainingPrizes: 6,
    totalPrizes: 8,
    prizePercentage: 0.75
    },
    {
    _id: "5d142a69f3130bb9ad5f1281",
    ticketNumber: 1416,
    ticketName: "TRIPLE IT!",
    topPrize: 3000,
    topPrizeRemaining: "55 of 84",
    ticketCost: 1,
    launchDate: "2019-04-08T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.88",
    gameImageLink: "http://www.flalottery.com/scratch/1416pic.jpg",
    State: "FL",
    remainingPrizes: 55,
    totalPrizes: 84,
    prizePercentage: 0.6547619048
    },
    {
    _id: "5d142a69f3130bb9ad5f1282",
    ticketNumber: 1415,
    ticketName: "$15,000,000 GOLD SPECIAL EDITI",
    topPrize: 1000000,
    topPrizeRemaining: "18 of 24",
    ticketCost: 30,
    launchDate: "2019-02-25T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-2.6",
    gameImageLink: "http://www.flalottery.com/scratch/1415pic.jpg",
    State: "FL",
    remainingPrizes: 18,
    totalPrizes: 24,
    prizePercentage: 0.75
    },
    {
    _id: "5d142a69f3130bb9ad5f1283",
    ticketNumber: 1412,
    ticketName: "MONEY BAGS",
    topPrize: 1000,
    topPrizeRemaining: "220 of 420",
    ticketCost: 1,
    launchDate: "2019-02-25T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.86",
    gameImageLink: "http://www.flalottery.com/scratch/1412pic.jpg",
    State: "FL",
    remainingPrizes: 220,
    totalPrizes: 420,
    prizePercentage: 0.5238095238
    },
    {
    _id: "5d142a69f3130bb9ad5f1284",
    ticketNumber: 1414,
    ticketName: "$1,000,000 LUCK",
    topPrize: 1000000,
    topPrizeRemaining: "3 of 8",
    ticketCost: 5,
    launchDate: "2019-02-25T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.04",
    gameImageLink: "http://www.flalottery.com/scratch/1414pic.jpg",
    State: "FL",
    remainingPrizes: 3,
    totalPrizes: 8,
    prizePercentage: 0.375
    },
    {
    _id: "5d142a69f3130bb9ad5f1285",
    ticketNumber: 1413,
    ticketName: "TRIPLE CA$H",
    topPrize: 30000,
    topPrizeRemaining: "7 of 10",
    ticketCost: 2,
    launchDate: "2019-02-25T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.54",
    gameImageLink: "http://www.flalottery.com/scratch/1413pic.jpg",
    State: "FL",
    remainingPrizes: 7,
    totalPrizes: 10,
    prizePercentage: 0.7
    },
    {
    _id: "5d142a69f3130bb9ad5f1286",
    ticketNumber: 1411,
    ticketName: "$2,000,000 GOLD RUSH CLASSIC",
    topPrize: 2000000,
    topPrizeRemaining: "6 of 10",
    ticketCost: 10,
    launchDate: "2019-01-14T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-3.49",
    gameImageLink: "http://www.flalottery.com/scratch/1411pic.jpg",
    State: "FL",
    remainingPrizes: 6,
    totalPrizes: 10,
    prizePercentage: 0.6
    },
    {
    _id: "5d142a69f3130bb9ad5f1287",
    ticketNumber: 1410,
    ticketName: "$1,000,000 GOLD RUSH CLASSIC",
    topPrize: 1000000,
    topPrizeRemaining: "21 of 32",
    ticketCost: 5,
    launchDate: "2019-01-14T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-3.97",
    gameImageLink: "http://www.flalottery.com/scratch/1410pic.jpg",
    State: "FL",
    remainingPrizes: 21,
    totalPrizes: 32,
    prizePercentage: 0.65625
    },
    {
    _id: "5d142a69f3130bb9ad5f1288",
    ticketNumber: 1409,
    ticketName: "$50,000 GOLD RUSH CLASSIC",
    topPrize: 50000,
    topPrizeRemaining: "46 of 72",
    ticketCost: 2,
    launchDate: "2019-01-14T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.69",
    gameImageLink: "http://www.flalottery.com/scratch/1409pic.jpg",
    State: "FL",
    remainingPrizes: 46,
    totalPrizes: 72,
    prizePercentage: 0.6388888889
    },
    {
    _id: "5d142a69f3130bb9ad5f1289",
    ticketNumber: 1415,
    ticketName: "$15,000,000 GOLD SPECIAL EDITI",
    topPrize: 15000000,
    topPrizeRemaining: "5 of 6",
    ticketCost: 30,
    launchDate: "2019-02-25T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-2.6",
    gameImageLink: "http://www.flalottery.com/scratch/1415pic.jpg",
    State: "FL",
    remainingPrizes: 5,
    totalPrizes: 6,
    prizePercentage: 0.8333333333
    },
    {
    _id: "5d142a69f3130bb9ad5f128a",
    ticketNumber: 1408,
    ticketName: "$10,000 GOLD RUSH CLASSIC",
    topPrize: 10000,
    topPrizeRemaining: "45 of 100",
    ticketCost: 1,
    launchDate: "2019-01-14T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.88",
    gameImageLink: "http://www.flalottery.com/scratch/1408pic.jpg",
    State: "FL",
    remainingPrizes: 45,
    totalPrizes: 100,
    prizePercentage: 0.45
    },
    {
    _id: "5d142a69f3130bb9ad5f128b",
    ticketNumber: 1405,
    ticketName: "2019 NEW YEAR'S DOUBLER",
    topPrize: 30000,
    topPrizeRemaining: "5 of 16",
    ticketCost: 2,
    launchDate: "2018-12-03T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.37",
    gameImageLink: "http://www.flalottery.com/scratch/1405pic.jpg",
    State: "FL",
    remainingPrizes: 5,
    totalPrizes: 16,
    prizePercentage: 0.3125
    },
    {
    _id: "5d142a69f3130bb9ad5f128c",
    ticketNumber: 1406,
    ticketName: "$500,000! CASH BLAST",
    topPrize: 500000,
    topPrizeRemaining: "2 of 6",
    ticketCost: 5,
    launchDate: "2018-12-03T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.03",
    gameImageLink: "http://www.flalottery.com/scratch/1406pic.jpg",
    State: "FL",
    remainingPrizes: 2,
    totalPrizes: 6,
    prizePercentage: 0.3333333333
    },
    {
    _id: "5d142a69f3130bb9ad5f128d",
    ticketNumber: 1403,
    ticketName: "LOTERIA",
    topPrize: 30000,
    topPrizeRemaining: "19 of 30*",
    ticketCost: 2,
    launchDate: "2018-12-03T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.5",
    gameImageLink: "http://www.flalottery.com/scratch/1403pic.jpg",
    State: "FL",
    remainingPrizes: 19,
    totalPrizes: 30,
    prizePercentage: 0.6333333333
    },
    {
    _id: "5d142a69f3130bb9ad5f128e",
    ticketNumber: 1404,
    ticketName: "Silver & Gold",
    topPrize: 5000,
    topPrizeRemaining: "24 of 84",
    ticketCost: 1,
    launchDate: "2018-12-03T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.88",
    gameImageLink: "http://www.flalottery.com/scratch/1404pic.jpg",
    State: "FL",
    remainingPrizes: 24,
    totalPrizes: 84,
    prizePercentage: 0.2857142857
    },
    {
    _id: "5d142a69f3130bb9ad5f128f",
    ticketNumber: 1401,
    ticketName: "$1,000,000 Holiday Bonus",
    topPrize: 1000000,
    topPrizeRemaining: "2 of 6",
    ticketCost: 5,
    launchDate: "2018-10-29T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.05",
    gameImageLink: "http://www.flalottery.com/scratch/1401pic.jpg",
    State: "FL",
    remainingPrizes: 2,
    totalPrizes: 6,
    prizePercentage: 0.3333333333
    },
    {
    _id: "5d142a69f3130bb9ad5f1290",
    ticketNumber: 1402,
    ticketName: "$2,000,000 Holiday Bonus",
    topPrize: 2000000,
    topPrizeRemaining: "1 of 2",
    ticketCost: 10,
    launchDate: "2018-10-29T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-3.39",
    gameImageLink: "http://www.flalottery.com/scratch/1402pic.jpg",
    State: "FL",
    remainingPrizes: 1,
    totalPrizes: 2,
    prizePercentage: 0.5
    },
    {
    _id: "5d142a69f3130bb9ad5f1291",
    ticketNumber: 1400,
    ticketName: "$50,000 Holiday Bonus",
    topPrize: 50000,
    topPrizeRemaining: "3 of 6",
    ticketCost: 2,
    launchDate: "2018-10-29T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.41",
    gameImageLink: "http://www.flalottery.com/scratch/1400pic.jpg",
    State: "FL",
    remainingPrizes: 3,
    totalPrizes: 6,
    prizePercentage: 0.5
    },
    {
    _id: "5d142a69f3130bb9ad5f1292",
    ticketNumber: 1399,
    ticketName: "$10,000 Holiday Bonus",
    topPrize: 10000,
    topPrizeRemaining: "10 of 36",
    ticketCost: 1,
    launchDate: "2018-10-29T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.88",
    gameImageLink: "http://www.flalottery.com/scratch/1399pic.jpg",
    State: "FL",
    remainingPrizes: 10,
    totalPrizes: 36,
    prizePercentage: 0.2777777778
    },
    {
    _id: "5d142a69f3130bb9ad5f1293",
    ticketNumber: 1398,
    ticketName: "$20 MONOPOLY JACKPOT",
    topPrize: 1000000,
    topPrizeRemaining: "12 of 20",
    ticketCost: 20,
    launchDate: "2018-09-17T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-2.97",
    gameImageLink: "http://www.flalottery.com/scratch/1398pic.jpg",
    State: "FL",
    remainingPrizes: 12,
    totalPrizes: 20,
    prizePercentage: 0.6
    },
    {
    _id: "5d142a69f3130bb9ad5f1294",
    ticketNumber: 1407,
    ticketName: "$5,000,000 GOLD RUSH CLASSIC",
    topPrize: 5000000,
    topPrizeRemaining: "3 of 6",
    ticketCost: 20,
    launchDate: "2018-10-08T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-2.99",
    gameImageLink: "http://www.flalottery.com/scratch/1407pic.jpg",
    State: "FL",
    remainingPrizes: 3,
    totalPrizes: 6,
    prizePercentage: 0.5
    },
    {
    _id: "5d142a69f3130bb9ad5f1295",
    ticketNumber: 1398,
    ticketName: "$20 MONOPOLY JACKPOT",
    topPrize: 5000000,
    topPrizeRemaining: "4 of 6",
    ticketCost: 20,
    launchDate: "2018-09-17T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-2.97",
    gameImageLink: "http://www.flalottery.com/scratch/1398pic.jpg",
    State: "FL",
    remainingPrizes: 4,
    totalPrizes: 6,
    prizePercentage: 0.6666666667
    },
    {
    _id: "5d142a69f3130bb9ad5f1296",
    ticketNumber: 1397,
    ticketName: "$500,000 PAYDAY",
    topPrize: 500000,
    topPrizeRemaining: "2 of 6",
    ticketCost: 5,
    launchDate: "2018-09-17T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.03",
    gameImageLink: "http://www.flalottery.com/scratch/1397pic.jpg",
    State: "FL",
    remainingPrizes: 2,
    totalPrizes: 6,
    prizePercentage: 0.3333333333
    },
    {
    _id: "5d142a69f3130bb9ad5f1297",
    ticketNumber: 1407,
    ticketName: "$5,000,000 GOLD RUSH CLASSIC",
    topPrize: 1000000,
    topPrizeRemaining: "19 of 30",
    ticketCost: 20,
    launchDate: "2018-10-08T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-2.99",
    gameImageLink: "http://www.flalottery.com/scratch/1407pic.jpg",
    State: "FL",
    remainingPrizes: 19,
    totalPrizes: 30,
    prizePercentage: 0.6333333333
    },
    {
    _id: "5d142a69f3130bb9ad5f1298",
    ticketNumber: 1394,
    ticketName: "EXTRA PLAY",
    topPrize: 500000,
    topPrizeRemaining: "0 of 8",
    ticketCost: 5,
    launchDate: "2018-08-06T00:00:00.000Z",
    endDate: "2019-06-21T00:00:00.000Z",
    redemptionDeadline: "2019-08-20T00:00:00.000Z",
    overallOddsOfWinning: "1-in-3.99",
    gameImageLink: "http://www.flalottery.com/scratch/1394pic.jpg",
    State: "FL",
    remainingPrizes: 0,
    totalPrizes: 8,
    prizePercentage: 0
    },
    {
    _id: "5d142a69f3130bb9ad5f1299",
    ticketNumber: 1395,
    ticketName: "HEADS OR TAILS",
    topPrize: 5000,
    topPrizeRemaining: "32 of 84",
    ticketCost: 1,
    launchDate: "2018-09-17T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.88",
    gameImageLink: "http://www.flalottery.com/scratch/1395pic.jpg",
    State: "FL",
    remainingPrizes: 32,
    totalPrizes: 84,
    prizePercentage: 0.380952381
    },
    {
    _id: "5d142a69f3130bb9ad5f129a",
    ticketNumber: 1396,
    ticketName: "WIN ALL!",
    topPrize: 20000,
    topPrizeRemaining: "6 of 30",
    ticketCost: 2,
    launchDate: "2018-09-17T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.5",
    gameImageLink: "http://www.flalottery.com/scratch/1396pic.jpg",
    State: "FL",
    remainingPrizes: 6,
    totalPrizes: 30,
    prizePercentage: 0.2
    },
    {
    _id: "5d142a69f3130bb9ad5f129b",
    ticketNumber: 1393,
    ticketName: "CROSSWORD CASH VAULT",
    topPrize: 50000,
    topPrizeRemaining: "13 of 40",
    ticketCost: 3,
    launchDate: "2018-08-06T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.14",
    gameImageLink: "http://www.flalottery.com/scratch/1393pic.jpg",
    State: "FL",
    remainingPrizes: 13,
    totalPrizes: 40,
    prizePercentage: 0.325
    },
    {
    _id: "5d142a69f3130bb9ad5f129c",
    ticketNumber: 1392,
    ticketName: "LUCKY 7",
    topPrize: 3000,
    topPrizeRemaining: "22 of 84",
    ticketCost: 1,
    launchDate: "2018-08-06T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.94",
    gameImageLink: "http://www.flalottery.com/scratch/1392pic.jpg",
    State: "FL",
    remainingPrizes: 22,
    totalPrizes: 84,
    prizePercentage: 0.2619047619
    },
    {
    _id: "5d142a69f3130bb9ad5f129d",
    ticketNumber: 1391,
    ticketName: "$10 MONOPOLY JACKPOT",
    topPrize: 2000000,
    topPrizeRemaining: "3 of 8",
    ticketCost: 10,
    launchDate: "2018-07-02T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-3.44",
    gameImageLink: "http://www.flalottery.com/scratch/1391pic.jpg",
    State: "FL",
    remainingPrizes: 3,
    totalPrizes: 8,
    prizePercentage: 0.375
    },
    {
    _id: "5d142a69f3130bb9ad5f129e",
    ticketNumber: 1389,
    ticketName: "$2 MONOPOLY JACKPOT",
    topPrize: 50000,
    topPrizeRemaining: "5 of 20",
    ticketCost: 2,
    launchDate: "2018-07-02T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.39",
    gameImageLink: "http://www.flalottery.com/scratch/1389pic.jpg",
    State: "FL",
    remainingPrizes: 5,
    totalPrizes: 20,
    prizePercentage: 0.25
    },
    {
    _id: "5d142a69f3130bb9ad5f129f",
    ticketNumber: 1390,
    ticketName: "$5 MONOPOLY JACKPOT",
    topPrize: 1000000,
    topPrizeRemaining: "2 of 8",
    ticketCost: 5,
    launchDate: "2018-07-02T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-3.98",
    gameImageLink: "http://www.flalottery.com/scratch/1390pic.jpg",
    State: "FL",
    remainingPrizes: 2,
    totalPrizes: 8,
    prizePercentage: 0.25
    },
    {
    _id: "5d142a69f3130bb9ad5f12a0",
    ticketNumber: 1385,
    ticketName: "DICE DOUBLER",
    topPrize: 5000,
    topPrizeRemaining: "22 of 84",
    ticketCost: 1,
    launchDate: "2018-05-21T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.87",
    gameImageLink: "http://www.flalottery.com/scratch/1385pic.jpg",
    State: "FL",
    remainingPrizes: 22,
    totalPrizes: 84,
    prizePercentage: 0.2619047619
    },
    {
    _id: "5d142a69f3130bb9ad5f12a1",
    ticketNumber: 1388,
    ticketName: "$1 MONOPOLY JACKPOT",
    topPrize: 10000,
    topPrizeRemaining: "63 of 136",
    ticketCost: 1,
    launchDate: "2018-07-02T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.95",
    gameImageLink: "http://www.flalottery.com/scratch/1388pic.jpg",
    State: "FL",
    remainingPrizes: 63,
    totalPrizes: 136,
    prizePercentage: 0.4632352941
    },
    {
    _id: "5d142a69f3130bb9ad5f12a2",
    ticketNumber: 1383,
    ticketName: "$2,000,000 24 KARAT CASH",
    topPrize: 2000000,
    topPrizeRemaining: "1 of 6*",
    ticketCost: 10,
    launchDate: "2018-04-09T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-3.57",
    gameImageLink: "http://www.flalottery.com/scratch/1383pic.jpg",
    State: "FL",
    remainingPrizes: 1,
    totalPrizes: 6,
    prizePercentage: 0.1666666667
    },
    {
    _id: "5d142a69f3130bb9ad5f12a3",
    ticketNumber: 1382,
    ticketName: "THE PRICE IS RIGHT",
    topPrize: 1000000,
    topPrizeRemaining: "2 of 6",
    ticketCost: 5,
    launchDate: "2018-04-09T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.19",
    gameImageLink: "http://www.flalottery.com/scratch/1382pic.jpg",
    State: "FL",
    remainingPrizes: 2,
    totalPrizes: 6,
    prizePercentage: 0.3333333333
    },
    {
    _id: "5d142a69f3130bb9ad5f12a4",
    ticketNumber: 1381,
    ticketName: "NEON 7's",
    topPrize: 30000,
    topPrizeRemaining: "3 of 26",
    ticketCost: 2,
    launchDate: "2018-04-09T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.41",
    gameImageLink: "http://www.flalottery.com/scratch/1381pic.jpg",
    State: "FL",
    remainingPrizes: 3,
    totalPrizes: 26,
    prizePercentage: 0.1153846154
    },
    {
    _id: "5d142a69f3130bb9ad5f12a5",
    ticketNumber: 1380,
    ticketName: "$100 IN A FLASH",
    topPrize: 3000,
    topPrizeRemaining: "13 of 84",
    ticketCost: 1,
    launchDate: "2018-04-09T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.97",
    gameImageLink: "http://www.flalottery.com/scratch/1380pic.jpg",
    State: "FL",
    remainingPrizes: 13,
    totalPrizes: 84,
    prizePercentage: 0.1547619048
    },
    {
    _id: "5d142a69f3130bb9ad5f12a6",
    ticketNumber: 1379,
    ticketName: "FLORIDA 100X THE CASH",
    topPrize: 1000000,
    topPrizeRemaining: "4 of 20",
    ticketCost: 30,
    launchDate: "2018-02-26T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-2.59",
    gameImageLink: "http://www.flalottery.com/scratch/1379pic.jpg",
    State: "FL",
    remainingPrizes: 4,
    totalPrizes: 20,
    prizePercentage: 0.2
    },
    {
    _id: "5d142a69f3130bb9ad5f12a7",
    ticketNumber: 1379,
    ticketName: "FLORIDA 100X THE CASH",
    topPrize: 15000000,
    topPrizeRemaining: "2 of 8",
    ticketCost: 30,
    launchDate: "2018-02-26T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-2.59",
    gameImageLink: "http://www.flalottery.com/scratch/1379pic.jpg",
    State: "FL",
    remainingPrizes: 2,
    totalPrizes: 8,
    prizePercentage: 0.25
    },
    {
    _id: "5d142a69f3130bb9ad5f12a8",
    ticketNumber: 1378,
    ticketName: "MONEY MACHINE",
    topPrize: 250000,
    topPrizeRemaining: "1 of 16",
    ticketCost: 5,
    launchDate: "2018-02-26T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.04",
    gameImageLink: "http://www.flalottery.com/scratch/1378pic.jpg",
    State: "FL",
    remainingPrizes: 1,
    totalPrizes: 16,
    prizePercentage: 0.0625
    },
    {
    _id: "5d142a69f3130bb9ad5f12a9",
    ticketNumber: 1376,
    ticketName: "TRIPLE PAYOUT",
    topPrize: 3000,
    topPrizeRemaining: "26 of 84",
    ticketCost: 1,
    launchDate: "2018-02-26T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.88",
    gameImageLink: "http://www.flalottery.com/scratch/1376pic.jpg",
    State: "FL",
    remainingPrizes: 26,
    totalPrizes: 84,
    prizePercentage: 0.3095238095
    },
    {
    _id: "5d142a69f3130bb9ad5f12aa",
    ticketNumber: 1377,
    ticketName: "$30,000 LUCKY WIN",
    topPrize: 30000,
    topPrizeRemaining: "3 of 30",
    ticketCost: 2,
    launchDate: "2018-02-26T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.53",
    gameImageLink: "http://www.flalottery.com/scratch/1377pic.jpg",
    State: "FL",
    remainingPrizes: 3,
    totalPrizes: 30,
    prizePercentage: 0.1
    },
    {
    _id: "5d142a69f3130bb9ad5f12ab",
    ticketNumber: 1375,
    ticketName: "FLORIDA 50X THE CASH",
    topPrize: 2000000,
    topPrizeRemaining: "0 of 12*",
    ticketCost: 10,
    launchDate: "2018-01-15T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-3.46",
    gameImageLink: "http://www.flalottery.com/scratch/1375pic.jpg",
    State: "FL",
    remainingPrizes: 0,
    totalPrizes: 12,
    prizePercentage: 0
    },
    {
    _id: "5d142a69f3130bb9ad5f12ac",
    ticketNumber: 1373,
    ticketName: "FLORIDA 10X THE CASH",
    topPrize: 50000,
    topPrizeRemaining: "1 of 40",
    ticketCost: 2,
    launchDate: "2018-01-15T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.68",
    gameImageLink: "http://www.flalottery.com/scratch/1373pic.jpg",
    State: "FL",
    remainingPrizes: 1,
    totalPrizes: 40,
    prizePercentage: 0.025
    },
    {
    _id: "5d142a69f3130bb9ad5f12ad",
    ticketNumber: 1372,
    ticketName: "FLORIDA 5X THE CASH",
    topPrize: 10000,
    topPrizeRemaining: "12 of 100",
    ticketCost: 1,
    launchDate: "2018-01-15T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.88",
    gameImageLink: "http://www.flalottery.com/scratch/1372pic.jpg",
    State: "FL",
    remainingPrizes: 12,
    totalPrizes: 100,
    prizePercentage: 0.12
    },
    {
    _id: "5d142a69f3130bb9ad5f12ae",
    ticketNumber: 1386,
    ticketName: "MONEY BAGS",
    topPrize: 30000,
    topPrizeRemaining: "0 of 10",
    ticketCost: 2,
    launchDate: "2018-05-21T00:00:00.000Z",
    endDate: "2019-06-21T00:00:00.000Z",
    redemptionDeadline: "2019-08-20T00:00:00.000Z",
    overallOddsOfWinning: "1-in-4.36",
    gameImageLink: "http://www.flalottery.com/scratch/1386pic.jpg",
    State: "FL",
    remainingPrizes: 0,
    totalPrizes: 10,
    prizePercentage: 0
    },
    {
    _id: "5d142a69f3130bb9ad5f12af",
    ticketNumber: 1371,
    ticketName: "SCRABBLE",
    topPrize: 50000,
    topPrizeRemaining: "9 of 40",
    ticketCost: 3,
    launchDate: "2017-12-04T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "TBA",
    gameImageLink: "http://www.flalottery.com/scratch/1371pic.jpg",
    State: "FL",
    remainingPrizes: 9,
    totalPrizes: 40,
    prizePercentage: 0.225
    },
    {
    _id: "5d142a69f3130bb9ad5f12b0",
    ticketNumber: 1363,
    ticketName: "BANKROLL BINGO",
    topPrize: 50000,
    topPrizeRemaining: "3 of 8",
    ticketCost: 3,
    launchDate: "2017-09-16T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-3.99",
    gameImageLink: "http://www.flalottery.com/scratch/1363pic.jpg",
    State: "FL",
    remainingPrizes: 3,
    totalPrizes: 8,
    prizePercentage: 0.375
    },
    {
    _id: "5d142a69f3130bb9ad5f12b1",
    ticketNumber: 1362,
    ticketName: "$10,000 A WEEK FOR LIFE",
    topPrize: 10000,
    topPrizeRemaining: "2 of 6*",
    ticketCost: 20,
    launchDate: "2017-09-16T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-2.97",
    gameImageLink: "http://www.flalottery.com/scratch/1362pic.jpg",
    State: "FL",
    remainingPrizes: 2,
    totalPrizes: 6,
    prizePercentage: 0.3333333333
    },
    {
    _id: "5d142a69f3130bb9ad5f12b2",
    ticketNumber: 1361,
    ticketName: "MONEY ROLL",
    topPrize: 20000,
    topPrizeRemaining: "8 of 30",
    ticketCost: 2,
    launchDate: "2017-09-16T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.5",
    gameImageLink: "http://www.flalottery.com/scratch/1361pic.jpg",
    State: "FL",
    remainingPrizes: 8,
    totalPrizes: 30,
    prizePercentage: 0.2666666667
    },
    {
    _id: "5d142a69f3130bb9ad5f12b3",
    ticketNumber: 1360,
    ticketName: "TRIPLE WIN",
    topPrize: 3000,
    topPrizeRemaining: "30 of 84",
    ticketCost: 1,
    launchDate: "2017-09-16T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.88",
    gameImageLink: "http://www.flalottery.com/scratch/1360pic.jpg",
    State: "FL",
    remainingPrizes: 30,
    totalPrizes: 84,
    prizePercentage: 0.3571428571
    },
    {
    _id: "5d142a69f3130bb9ad5f12b4",
    ticketNumber: 1359,
    ticketName: "$2,000,000 CASHWORD",
    topPrize: 2000000,
    topPrizeRemaining: "1 of 9*",
    ticketCost: 10,
    launchDate: "2017-08-07T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-3.38",
    gameImageLink: "http://www.flalottery.com/scratch/1359pic.jpg",
    State: "FL",
    remainingPrizes: 1,
    totalPrizes: 9,
    prizePercentage: 0.1111111111
    },
    {
    _id: "5d142a69f3130bb9ad5f12b5",
    ticketNumber: 1357,
    ticketName: "CA$H Payout",
    topPrize: 30000,
    topPrizeRemaining: "2 of 10",
    ticketCost: 2,
    launchDate: "2017-08-07T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.36",
    gameImageLink: "http://www.flalottery.com/scratch/1357pic.jpg",
    State: "FL",
    remainingPrizes: 2,
    totalPrizes: 10,
    prizePercentage: 0.2
    },
    {
    _id: "5d142a69f3130bb9ad5f12b6",
    ticketNumber: 1355,
    ticketName: "2's FOR THE MONEY",
    topPrize: 3000,
    topPrizeRemaining: "22 of 84",
    ticketCost: 1,
    launchDate: "2017-08-07T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.94",
    gameImageLink: "http://www.flalottery.com/scratch/1355pic.jpg",
    State: "FL",
    remainingPrizes: 22,
    totalPrizes: 84,
    prizePercentage: 0.2619047619
    },
    {
    _id: "5d142a69f3130bb9ad5f12b7",
    ticketNumber: 1354,
    ticketName: "VERY CHERRY",
    topPrize: 5000,
    topPrizeRemaining: "9 of 70",
    ticketCost: 1,
    launchDate: "2017-05-23T00:00:00.000Z",
    endDate: "2019-06-21T00:00:00.000Z",
    redemptionDeadline: "2019-08-20T00:00:00.000Z",
    overallOddsOfWinning: "1-in-4.94",
    gameImageLink: "http://www.flalottery.com/scratch/1354pic.jpg",
    State: "FL",
    remainingPrizes: 9,
    totalPrizes: 70,
    prizePercentage: 0.1285714286
    },
    {
    _id: "5d142a69f3130bb9ad5f12b8",
    ticketNumber: 1369,
    ticketName: "SILVER DOLLAR",
    topPrize: 1000,
    topPrizeRemaining: "68 of 600",
    ticketCost: 1,
    launchDate: "2017-12-04T00:00:00.000Z",
    endDate: "2019-06-21T00:00:00.000Z",
    redemptionDeadline: "2019-08-20T00:00:00.000Z",
    overallOddsOfWinning: "1-in-4.81",
    gameImageLink: "http://www.flalottery.com/scratch/1369pic.jpg",
    State: "FL",
    remainingPrizes: 68,
    totalPrizes: 600,
    prizePercentage: 0.1133333333
    },
    {
    _id: "5d142a69f3130bb9ad5f12b9",
    ticketNumber: 1351,
    ticketName: "$1,000 A WEEK FOR LIFE",
    topPrize: 1000,
    topPrizeRemaining: "1 of 8",
    ticketCost: 2,
    launchDate: "2017-07-03T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.43",
    gameImageLink: "http://www.flalottery.com/scratch/1351pic.jpg",
    State: "FL",
    remainingPrizes: 1,
    totalPrizes: 8,
    prizePercentage: 0.125
    },
    {
    _id: "5d142a69f3130bb9ad5f12ba",
    ticketNumber: 1364,
    ticketName: "LUCKY 13",
    topPrize: 250000,
    topPrizeRemaining: "7 of 16",
    ticketCost: 5,
    launchDate: "2017-09-16T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.01",
    gameImageLink: "http://www.flalottery.com/scratch/1364pic.jpg",
    State: "FL",
    remainingPrizes: 7,
    totalPrizes: 16,
    prizePercentage: 0.4375
    },
    {
    _id: "5d142a69f3130bb9ad5f12bb",
    ticketNumber: 1349,
    ticketName: "TOPAZ 10's",
    topPrize: 250000,
    topPrizeRemaining: "5 of 16",
    ticketCost: 5,
    launchDate: "2017-04-11T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.01",
    gameImageLink: "http://www.flalottery.com/scratch/1349pic.jpg",
    State: "FL",
    remainingPrizes: 5,
    totalPrizes: 16,
    prizePercentage: 0.3125
    },
    {
    _id: "5d142a69f3130bb9ad5f12bc",
    ticketNumber: 1344,
    ticketName: "LUCKY 7's CROSSWORD",
    topPrize: 250000,
    topPrizeRemaining: "0 of 24",
    ticketCost: 5,
    launchDate: "2017-05-23T00:00:00.000Z",
    endDate: "2019-06-21T00:00:00.000Z",
    redemptionDeadline: "2019-08-20T00:00:00.000Z",
    overallOddsOfWinning: "1-in-3.99",
    gameImageLink: "http://www.flalottery.com/scratch/1344pic.jpg",
    State: "FL",
    remainingPrizes: 0,
    totalPrizes: 24,
    prizePercentage: 0
    },
    {
    _id: "5d142a69f3130bb9ad5f12bd",
    ticketNumber: 1342,
    ticketName: "CASH ON THE SPOT",
    topPrize: 5000,
    topPrizeRemaining: "19 of 84",
    ticketCost: 1,
    launchDate: "2017-04-11T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.88",
    gameImageLink: "http://www.flalottery.com/scratch/1342pic.jpg",
    State: "FL",
    remainingPrizes: 19,
    totalPrizes: 84,
    prizePercentage: 0.2261904762
    },
    {
    _id: "5d142a69f3130bb9ad5f12be",
    ticketNumber: 1341,
    ticketName: "LOTERIA GRANDE",
    topPrize: 250000,
    topPrizeRemaining: "6 of 16",
    ticketCost: 5,
    launchDate: "2017-03-16T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-3.98",
    gameImageLink: "http://www.flalottery.com/scratch/1341pic.jpg",
    State: "FL",
    remainingPrizes: 6,
    totalPrizes: 16,
    prizePercentage: 0.375
    },
    {
    _id: "5d142a69f3130bb9ad5f12bf",
    ticketNumber: 1340,
    ticketName: "LOTERIA",
    topPrize: 30000,
    topPrizeRemaining: "7 of 30",
    ticketCost: 2,
    launchDate: "2017-03-16T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.5",
    gameImageLink: "http://www.flalottery.com/scratch/1340pic.jpg",
    State: "FL",
    remainingPrizes: 7,
    totalPrizes: 30,
    prizePercentage: 0.2333333333
    },
    {
    _id: "5d142a69f3130bb9ad5f12c0",
    ticketNumber: 1338,
    ticketName: "CASH RESERVE",
    topPrize: 250000,
    topPrizeRemaining: "4 of 16",
    ticketCost: 5,
    launchDate: "2017-02-28T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.03",
    gameImageLink: "http://www.flalottery.com/scratch/1338pic.jpg",
    State: "FL",
    remainingPrizes: 4,
    totalPrizes: 16,
    prizePercentage: 0.25
    },
    {
    _id: "5d142a69f3130bb9ad5f12c1",
    ticketNumber: 1335,
    ticketName: "$2,000,000 GOLD RUSH DOUBLER",
    topPrize: 2000000,
    topPrizeRemaining: "1 of 8",
    ticketCost: 10,
    launchDate: "2017-01-17T00:00:00.000Z",
    endDate: "2017-01-17T00:00:00.000Z",
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-3.41",
    gameImageLink: "http://www.flalottery.com/scratch/1335pic.jpg",
    State: "FL",
    remainingPrizes: 1,
    totalPrizes: 8,
    prizePercentage: 0.125
    },
    {
    _id: "5d142a69f3130bb9ad5f12c2",
    ticketNumber: 1334,
    ticketName: "$500,000 GOLD RUSH DOUBLER",
    topPrize: 500000,
    topPrizeRemaining: "1 of 44",
    ticketCost: 5,
    launchDate: "2017-01-17T00:00:00.000Z",
    endDate: "2017-01-17T00:00:00.000Z",
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-3.98",
    gameImageLink: "http://www.flalottery.com/scratch/1334pic.jpg",
    State: "FL",
    remainingPrizes: 1,
    totalPrizes: 44,
    prizePercentage: 0.0227272727
    },
    {
    _id: "5d142a69f3130bb9ad5f12c3",
    ticketNumber: 1348,
    ticketName: "BONUS DOUBLE MATCH",
    topPrize: 250000,
    topPrizeRemaining: "2 of 16",
    ticketCost: 5,
    launchDate: "2017-05-23T00:00:00.000Z",
    endDate: "2019-06-21T00:00:00.000Z",
    redemptionDeadline: "2019-08-20T00:00:00.000Z",
    overallOddsOfWinning: "1-in-4.03",
    gameImageLink: "http://www.flalottery.com/scratch/1348pic.jpg",
    State: "FL",
    remainingPrizes: 2,
    totalPrizes: 16,
    prizePercentage: 0.125
    },
    {
    _id: "5d142a69f3130bb9ad5f12c4",
    ticketNumber: 1343,
    ticketName: "$30 GRAND",
    topPrize: 30000,
    topPrizeRemaining: "2 of 12",
    ticketCost: 2,
    launchDate: "2017-04-11T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.37",
    gameImageLink: "http://www.flalottery.com/scratch/1343pic.jpg",
    State: "FL",
    remainingPrizes: 2,
    totalPrizes: 12,
    prizePercentage: 0.1666666667
    },
    {
    _id: "5d142a69f3130bb9ad5f12c5",
    ticketNumber: 1333,
    ticketName: "$50,000 GOLD RUSH DOUBLER",
    topPrize: 50000,
    topPrizeRemaining: "3 of 72",
    ticketCost: 2,
    launchDate: "2017-01-17T00:00:00.000Z",
    endDate: "2017-01-17T00:00:00.000Z",
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.69",
    gameImageLink: "http://www.flalottery.com/scratch/1333pic.jpg",
    State: "FL",
    remainingPrizes: 3,
    totalPrizes: 72,
    prizePercentage: 0.0416666667
    },
    {
    _id: "5d142a69f3130bb9ad5f12c6",
    ticketNumber: 1332,
    ticketName: "$10,000 GOLD RUSH DOUBLER",
    topPrize: 10000,
    topPrizeRemaining: "2 of 100",
    ticketCost: 1,
    launchDate: "2017-01-17T00:00:00.000Z",
    endDate: "2017-01-17T00:00:00.000Z",
    redemptionDeadline: "2019-08-20T00:00:00.000Z",
    overallOddsOfWinning: "1-in-4.88",
    gameImageLink: "http://www.flalottery.com/scratch/1332pic.jpg",
    State: "FL",
    remainingPrizes: 2,
    totalPrizes: 100,
    prizePercentage: 0.02
    },
    {
    _id: "5d142a69f3130bb9ad5f12c7",
    ticketNumber: 1318,
    ticketName: "MAXIMUM MONEY",
    topPrize: 250000,
    topPrizeRemaining: "0 of 12",
    ticketCost: 5,
    launchDate: "2016-08-09T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.04",
    gameImageLink: "http://www.flalottery.com/scratch/1318pic.jpg",
    State: "FL",
    remainingPrizes: 0,
    totalPrizes: 12,
    prizePercentage: 0
    },
    {
    _id: "5d142a69f3130bb9ad5f12c8",
    ticketNumber: 1331,
    ticketName: "MONEY MONEY MONEY",
    topPrize: 250000,
    topPrizeRemaining: "3 of 12",
    ticketCost: 5,
    launchDate: "2016-12-06T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-3.99",
    gameImageLink: "http://www.flalottery.com/scratch/1331pic.jpg",
    State: "FL",
    remainingPrizes: 3,
    totalPrizes: 12,
    prizePercentage: 0.25
    },
    {
    _id: "5d142a69f3130bb9ad5f12c9",
    ticketNumber: 1305,
    ticketName: "EA$Y MONEY",
    topPrize: 25000,
    topPrizeRemaining: "1 of 10",
    ticketCost: 2,
    launchDate: "2016-04-05T00:00:00.000Z",
    endDate: "2019-06-21T00:00:00.000Z",
    redemptionDeadline: "2019-08-20T00:00:00.000Z",
    overallOddsOfWinning: "1-in-4.36",
    gameImageLink: "http://www.flalottery.com/scratch/1305pic.jpg",
    State: "FL",
    remainingPrizes: 1,
    totalPrizes: 10,
    prizePercentage: 0.1
    },
    {
    _id: "5d142a69f3130bb9ad5f12ca",
    ticketNumber: 1302,
    ticketName: "WINNING STREAK",
    topPrize: 250000,
    topPrizeRemaining: "6 of 20*",
    ticketCost: 5,
    launchDate: "2016-02-23T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.03",
    gameImageLink: "http://www.flalottery.com/scratch/1302pic.jpg",
    State: "FL",
    remainingPrizes: 6,
    totalPrizes: 20,
    prizePercentage: 0.3
    },
    {
    _id: "5d142a69f3130bb9ad5f12cb",
    ticketNumber: 1259,
    ticketName: "$50,000 GOLD RUSH",
    topPrize: 50000,
    topPrizeRemaining: "8 of 80*",
    ticketCost: 2,
    launchDate: "2015-01-13T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.68",
    gameImageLink: "http://www.flalottery.com/scratch/1259pic.jpg",
    State: "FL",
    remainingPrizes: 8,
    totalPrizes: 80,
    prizePercentage: 0.1
    },
    {
    _id: "5d142a69f3130bb9ad5f12cc",
    ticketNumber: 1298,
    ticketName: "$500,000 FLAMINGO MULTIPLIER",
    topPrize: 500000,
    topPrizeRemaining: "7 of 24*",
    ticketCost: 5,
    launchDate: "2016-01-12T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.23",
    gameImageLink: "http://www.flalottery.com/scratch/1298pic.jpg",
    State: "FL",
    remainingPrizes: 7,
    totalPrizes: 24,
    prizePercentage: 0.2916666667
    },
    {
    _id: "5d142a69f3130bb9ad5f12cd",
    ticketNumber: 1245,
    ticketName: "ESCAPE TO MARGARITAVILLE",
    topPrize: 250000,
    topPrizeRemaining: "4 of 10*",
    ticketCost: 5,
    launchDate: "2014-04-05T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.02",
    gameImageLink: "http://www.flalottery.com/scratch/1245pic.jpg",
    State: "FL",
    remainingPrizes: 4,
    totalPrizes: 10,
    prizePercentage: 0.4
    },
    {
    _id: "5d142a69f3130bb9ad5f12ce",
    ticketNumber: 1048,
    ticketName: "LUCKY $200,000 A YEAR FOR LIFE",
    topPrize: 200000,
    topPrizeRemaining: "1 of 10*",
    ticketCost: 20,
    launchDate: "2010-01-05T00:00:00.000Z",
    endDate: "2019-10-19T00:00:00.000Z",
    redemptionDeadline: "2019-12-18T00:00:00.000Z",
    overallOddsOfWinning: "1-in-2.94",
    gameImageLink: "http://www.flalottery.com/scratch/1048pic.jpg",
    State: "FL",
    remainingPrizes: 1,
    totalPrizes: 10,
    prizePercentage: 0.1
    },
    {
    _id: "5d142a69f3130bb9ad5f12cf",
    ticketNumber: 1297,
    ticketName: "$50,000 FLAMINGO MULTIPLIER",
    topPrize: 50000,
    topPrizeRemaining: "13 of 40*",
    ticketCost: 2,
    launchDate: "2016-01-12T00:00:00.000Z",
    endDate: null,
    redemptionDeadline: null,
    overallOddsOfWinning: "1-in-4.68",
    gameImageLink: "http://www.flalottery.com/scratch/1297pic.jpg",
    State: "FL",
    remainingPrizes: 13,
    totalPrizes: 40,
    prizePercentage: 0.325
    },
    {
    _id: "5d142a69f3130bb9ad5f12d0",
    ticketNumber: 1048,
    ticketName: "LUCKY $200,000 A YEAR FOR LIFE",
    topPrize: 50000,
    topPrizeRemaining: "4 of 10*",
    ticketCost: 20,
    launchDate: "2010-01-05T00:00:00.000Z",
    endDate: "2019-10-19T00:00:00.000Z",
    redemptionDeadline: "2019-12-18T00:00:00.000Z",
    overallOddsOfWinning: "1-in-2.94",
    gameImageLink: "http://www.flalottery.com/scratch/1048pic.jpg",
    State: "FL",
    remainingPrizes: 4,
    totalPrizes: 10,
    prizePercentage: 0.4
    }
    ]
    